import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { Language, Namespace } from 'enums';

import en from './locales/en';
import ru from './locales/ru';

i18n.use(initReactI18next).init({
  resources: {
    [Language.EN]: en,
    [Language.RU]: ru,
  },
  lng: Language.RU,
  interpolation: {
    escapeValue: false,
  },
  fallbackNS: Namespace.Common,
});

export default i18n;
